var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quiz-progress"},[_c('div',{staticClass:"quiz-progress__container"},[_c('span',{staticClass:"quiz-progress__indicator",style:({ width: `${_vm.progress}%`, transition: 'width 0.5s ease-out' })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }